import { getDateInFormat } from "@domains/utils/reportDates";
import React from "react";
import { Col, Row } from "react-bootstrap";
const NewTicketFixedRow = () => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: "brd-top mx-0 ticketportal-padding commonlineheight-mb pt-4 active-bg-gray" },
            React.createElement(Col, { lg: 12, className: "px-0 grid-2 justify-content-between" },
                React.createElement("div", { className: "DMSanM_14_500 textOverflow-max272" }, "New Ticket")),
            React.createElement(Col, { lg: 12, className: "px-0 linehei14" },
                React.createElement("span", { className: "DMSansMedium_12_500 txt_secondary-gray" }, getDateInFormat(new Date(), "DD-MM-YYYY hh:mm:ss A"))))));
};
export default NewTicketFixedRow;
